

import templatePop from '../views/studentpopup-list.html';
class StudentFilteration {
    constructor($scope, $state, $stateParams, $sce, $rootScope,
        authService, localStorageService, RESULT_ANALYSIS_CONSTANTS, CONSTANTS, $mdMedia, $mdDialog) {
        'ngInject';
        $rootScope.title = "Individual Student Report"
        let self = this
        $scope.loading = true
        self.typeArray = undefined
        self.levelArray = undefined
        self.resPerTheme = undefined
        self.tagArr = undefined
        self.data_set = undefined
        self.header = undefined
        self.perTypeObj = {}
        
        self.perTagObj = {}
        self.perLevelObj = {}
        self.themeTotal = undefined
        self.no_of_students = undefined
        self.allThemeTotal = {}
        self.noData = true
        $scope.view_only = false
        $scope.filterObj = {}
        self.noAcademics = true
        let myUserId = localStorageService.get('user_id')
        let activeAcd = localStorageService.get('academic_year')
        let school_id = localStorageService.get('school_id')
        let thisSchoolId = school_id
        let filterThru = localStorageService.get('can_filter')
        $scope.allAcademic_year = localStorageService.get('allAcademic_year')
        // let currentYear= _.find(allAcademic_year, function (object) {
        //     return object.status == 'active'
        // })
        
        if (filterThru == "true") {
            filterThru = true
        } else {
            filterThru = undefined
        }
        var insideCourseware = false
        let LEVEL_ARRAY = [{
            level: "1",
            alias: "Easy"
        }, {
            level: "2",
            alias: "Medium"
        }, {
            level: "3",
            alias: "Difficult"
        }]
        //Boolean - To set view for fetch
        $scope.isFilter = true;

        //Object - Holds selection data
        $scope.selectAcademics = {};

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Individual Student Report"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            getSession()
        }
        $scope.barcodeToHtml = function () {
            let lines = $scope.REFERENCE.bcode.lines
            let barcodeNumber = $scope.REFERENCE.bcode.barcodeNumber
            return $sce.trustAsHtml(lines+barcodeNumber);
        }

        function getSession() {
            $scope.toSearchObj = {
                user_id: myUserId,
                school_id: school_id,
                academic_year: activeAcd,
                exam: {
                    $exists: 1
                }
            }
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SESSION_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.sessions = response.result.data.details;
                        $scope.selectAcademics.session = undefined;
                        $scope.selectAcademics.curriculum = undefined;
                        $scope.selectAcademics.class = undefined;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.curriculums = [];
                        $scope.classes = [];
                        $scope.batches = [];
                        $scope.subjects = [];
                        $scope.loading = false;
                    } catch (ex) {
                        console.log(ex)
                    }
                } else {
                    $scope.loading = false
                    toastr.error('Network Error. Please try later')
                }
                _.defer(function () {
                    $scope.$apply();
                });
            })
        }
        
        $scope.getCuriculum = (session) => {
            setAcademic()
            $scope.selectAcademics.session = session;
            $scope.toSearchObj.session = $scope.selectAcademics.session._id;
            
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CURRICULUM_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.curriculums = response.result.data.details;
                        $scope.selectAcademics.curriculum = undefined;
                        $scope.selectAcademics.class = undefined;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.classes = [];
                        $scope.batches = [];
                        $scope.subjects = [];
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        $scope.getClass = (curriculum) => {
            setAcademic()
            $scope.selectAcademics.curriculum = curriculum;
            $scope.toSearchObj.curriculum = $scope.selectAcademics.curriculum._id;
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CLASS_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.classes = response.result.data.details;
                        $scope.selectAcademics.class = undefined;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.batches = [];
                        $scope.subjects = [];
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        $scope.getBatch = (xclass) => {
            setAcademic()
            $scope.selectAcademics.class = xclass;
            $scope.toSearchObj.class = $scope.selectAcademics.class._id;
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_BATCH_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.batches = response.result.data.details;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.subjects = [];
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        $scope.getSubject = (batch) => {
            setAcademic()
            $scope.selectAcademics.batch = batch;
            $scope.selectAcademics.subject = undefined;
            $scope.toSearchObj.batch = $scope.selectAcademics.batch._id;
            if($scope.toSearchObj && $scope.toSearchObj.academic_year){
                if($scope.toSearchObj.academic_year.year){
                    $scope.toSearchObj.academic_year = $scope.toSearchObj.academic_year.year
                }
            }
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SUBJECT_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.subjects = response.result.data.details;
                        
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }
        $scope.fetchReport = function (subject) {
            $scope.selectAcademics.subject = subject;
            $scope.selectedAcademics = angular.copy($scope.selectAcademics);
            $scope.toSearchObj.subject = $scope.selectAcademics.subject._id;
            
        }
        $scope.getReport = (academic_year) => {
            $scope.toSearchObj.academic_year = academic_year;
            
        }
        $scope.findReport = () => {
            $scope.getStudents($scope.toSearchObj)
        }
        $scope.getStudents = (toSearchObj) => {
            
            if (toSearchObj) {
                
                var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                $mdDialog.show({
                    template: templatePop,
                    controller: ['$scope', '$mdDialog', "toSearchObj", "authService", 'parentScopeObj',
                        'localStorageService', StudentsCtrl],
                    parent: angular.element(document.body),
                    locals: {
                        toSearchObj: toSearchObj,
                        parentScopeObj: $scope,
                        authService: authService,
                        localStorageService: localStorageService
                    },
                    clickOutsideToClose: true,
                    fullscreen: true
                })
                    .then(function () {

                    }, function () {
                        $scope.status = 'You cancelled the dialog.';
                    });
            }
        }
        $scope.uCanTrust = function (obj) {
            // string = "<span style='color: #89a000'>123</span>"
            if (obj && obj.color) {
                let color = obj.color['background-color']
                let string = '<span class="td-color" style="background-color:' + color + ';">' + obj.score + '</span>';
                return $sce.trustAsHtml(string);
            }

        }
        $scope.getStudentReport = (academics, user_id) => {
            
            $scope.loading = true
            let send = {
                "conditions": {
                    "class_id": academics.class_id,
                    "curriculum_id": academics.curriculum_id,
                    "batch_id": academics.batch_id,
                    "subject_id": academics.subject_id,
                    "session_id": academics.session_id,
                    "school_id": academics.school_id
                },
                "myUserId": myUserId,
                "acdYear": academics.academic_year ? academics.academic_year : activeAcd,
                "student_id": user_id,
                "pdfFlag": false,
                "FILE_UPLOAD_URL": CONSTANTS.FILE_UPLOAD_URL,
                "SITE_URL": CONSTANTS.FILE_UPLOAD_URL+"/uploads/"
            }
            authService.callAPI("/v0/educore_reports/individual_report", "POST",
                { args: send }, function (resp) {
                    try {
                        if (!resp.error) {
                            let response = resp.result.data.details
                            console.log(response)
                            self.activitiesConducted = response.activitiesConducted ? response.activitiesConducted : []

                            $scope.REFERENCE = response.REFERENCE
                            let data_set = response.typesArr
                            data_set = _.groupBy(data_set, function (val) {
                                return val.theme_id
                            })
                            if (response.activitiesConducted.length) {
                                self.noData = false
                            } else {
                                self.noData = true
                            }

                            let obj = {}
                            let levelObj = {}
                            let tagObj = {}
                            let themeArray = []
                            let typeArray = response.pluckTypes
                            let tagArray = response.tagArray
                            _.each(data_set, function (array, themeId) {
                                obj[themeId] = {}
                                levelObj[themeId] = {}
                                tagObj[themeId] = {}
                                themeArray.push(themeId)
                                let pluckTypeThiisTheme = _.uniq(_.pluck(array, "type"))
                                _.each(pluckTypeThiisTheme, function (oneType) {
                                    let findThisType = _.filter(array, function (object) {
                                        return object.type == oneType
                                    })
                                    let score = undefined
                                    if (findThisType) {
                                        score = findThisType.sum("score")
                                    }
                                    obj[themeId][oneType] = score
                                })
                                _.each(LEVEL_ARRAY, function (oneLevel) {
                                    let findThisLevel = _.filter(array, function (object) {
                                        return object && object.level && 
                                        object.level.length && object.level.indexOf(oneLevel.level) != -1
                                    })
                                    let score = undefined
                                    score = findThisLevel ? findThisLevel.sum("score") : 0
                                    levelObj[themeId][oneLevel.alias] = score
                                })

                                _.each(tagArray, function (oneTag) {
                                    let findThisTag = _.filter(array, function (object) {
                                        return object && object.tags && object.tags.indexOf(oneTag) != -1
                                    })
                                    let score = undefined
                                    score = findThisTag ? findThisTag.sum("score") : 0
                                    tagObj[themeId][oneTag] = score
                                })

                            })

                            self.level_set = levelObj
                            self.levels = LEVEL_ARRAY
                            self.data_set = obj
                            self.typeArray = typeArray
                            self.tagArray = tagArray
                            self.tag_set = tagObj
                            let themeCount = 1
                            _.each(response.themesArr, function (oneTheme) {
                                oneTheme.alias = "C" + themeCount
                                themeCount++
                            })
                            self.themeArray = response.themesArr;
                            self.data = response.data
                            self.level = response.level
                            self.tag = response.tag
                            self.avgPerTheme = response.avgPerTheme
                            self.avgTagPerTheme = response.avgTagPerTheme
                            self.avgLevelPerTheme = response.avgLevelPerTheme

                            self.typeOver = response.typeOver
                            self.levelOver = response.levelOver
                            self.tagOver = response.tagOver
                            self.header = response.header
                            self.classMethod = response.classMethod
                            self.generator = response.generator
                            self.allThemeTotal = response.allThemeTotal
                            self.highest = response.highest
                            self.allThemeLevelObj = response.allThemeLevelObj
                            self.allThemeTagObj = response.allThemeTagObj
                            let colSpanCountTag = 4 //setting collspan length in tag overalll
                            colSpanCountTag = colSpanCountTag + response.themesArr.length
                            self.tagCollSpan = colSpanCountTag
                            $scope.urls =  response.pdfdata
                        } else {
                            self.noData = true
                        }
                        $scope.loading = false
                        $scope.$apply();
                    } catch (e) {
                        $scope.loading = false
                        console.log(e)
                    }
                });
        }



        // self.export = () => {
        //     $scope.loading = true

        // }
        self.export = () => {
            $scope.loading = true
            $scope.pdfData = true

            $scope.url = $sce.trustAsResourceUrl($scope.urls)
            
            $scope.loading = false
            _.defer(function() { $scope.$apply(); });;
        }
        self.backToHtml = () => {
            $scope.pdfData = false
        }
        $scope.ref_code = undefined
        $scope.submitRefCode = () => {
            $scope.loading = true
            authService.callAPI("/v0/educore-reports/getreportbyreference", "POST",
                { args: {
                    ref_code : $scope.ref_code,
                    type : 'student_report',
                    FILE_UPLOAD_URL : CONSTANTS.FILE_UPLOAD_URL,
                    user_id : myUserId
                } }, function (resp) {
                    try{
                        if (!resp.error) {
                            let response = resp.result.data.details
                            $scope.reference_data = resp.result.data.reference_data
                            console.log($scope.reference_data)
                            self.activitiesConducted = response.activitiesConducted ? response.activitiesConducted : []


                            let data_set = response.typesArr
                            data_set = _.groupBy(data_set, function (val) {
                                return val.theme_id
                            })
                            if (response.activitiesConducted.length) {
                                self.noData = false
                            } else {
                                self.noData = true
                            }

                            let obj = {}
                            let levelObj = {}
                            let tagObj = {}
                            let themeArray = []
                            let typeArray = response.pluckTypes
                            let tagArray = response.tagArray
                            _.each(data_set, function (array, themeId) {
                                obj[themeId] = {}
                                levelObj[themeId] = {}
                                tagObj[themeId] = {}
                                themeArray.push(themeId)
                                let pluckTypeThiisTheme = _.uniq(_.pluck(array, "type"))
                                _.each(pluckTypeThiisTheme, function (oneType) {
                                    let findThisType = _.filter(array, function (object) {
                                        return object.type == oneType
                                    })
                                    let score = undefined
                                    if (findThisType) {
                                        score = findThisType.sum("score")
                                    }
                                    obj[themeId][oneType] = score
                                })
                                _.each(LEVEL_ARRAY, function (oneLevel) {
                                    let findThisLevel = _.filter(array, function (object) {
                                        return object.level.indexOf(oneLevel.level) != -1
                                    })
                                    let score = undefined
                                    score = findThisLevel ? findThisLevel.sum("score") : 0
                                    levelObj[themeId][oneLevel.alias] = score
                                })

                                _.each(tagArray, function (oneTag) {
                                    let findThisTag = _.filter(array, function (object) {
                                        return object && object.tags && object.tags.indexOf(oneTag) != -1
                                    })
                                    let score = undefined
                                    score = findThisTag ? findThisTag.sum("score") : 0
                                    tagObj[themeId][oneTag] = score
                                })

                            })

                            self.level_set = levelObj
                            self.levels = LEVEL_ARRAY
                            self.data_set = obj
                            self.typeArray = typeArray
                            self.tagArray = tagArray
                            self.tag_set = tagObj
                            let themeCount = 1
                            _.each(response.themesArr, function (oneTheme) {
                                oneTheme.alias = "C" + themeCount
                                themeCount++
                            })
                            self.themeArray = response.themesArr;
                            self.data = response.data
                            self.level = response.level
                            self.tag = response.tag
                            self.avgPerTheme = response.avgPerTheme
                            self.avgTagPerTheme = response.avgTagPerTheme
                            self.avgLevelPerTheme = response.avgLevelPerTheme

                            self.typeOver = response.typeOver
                            self.levelOver = response.levelOver
                            self.tagOver = response.tagOver
                            self.header = response.header
                            self.classMethod = response.classMethod
                            self.generator = response.generator
                            self.allThemeTotal = response.allThemeTotal
                            self.highest = response.highest
                            self.allThemeLevelObj = response.allThemeLevelObj
                            self.allThemeTagObj = response.allThemeTagObj
                            let colSpanCountTag = 4 //setting collspan length in tag overalll
                            colSpanCountTag = colSpanCountTag + response.themesArr.length
                            self.tagCollSpan = colSpanCountTag
                            $scope.urls =  response.pdfdata
                        } else {
                            self.noData = true
                        }
                        $scope.loading = false
                        $scope.$apply();
                    }catch(e){
                        console.log(e)
                    }
                })
        }

        function setAcademic(){
            if($scope.toSearchObj && $scope.toSearchObj.academic_year && $scope.toSearchObj.academic_year._id){
                $scope.toSearchObj.academic_year = $scope.toSearchObj.academic_year.year
            }
        }

    }
}
Array.prototype.sum = function (prop) {
    var total = 0
    for (var i = 0, _len = this.length; i < _len; i++) {
        total += this[i][prop]
    }
    return total
}
class StudentsCtrl {
    constructor($scope, $mdDialog, toSearchObj, authService, parentScopeObj,
        localStorageService) {
        let send = {
            session_id: toSearchObj.session,
            curriculum_id: toSearchObj.curriculum,
            class_id: toSearchObj.class,
            batch_id: toSearchObj.batch,
            subject_id: toSearchObj.subject,
            school_id: toSearchObj.school_id,
            academic_year : toSearchObj.academic_year.year
        }
        
        authService.callAPI("/v0/educore_reports/student/list", "POST",
            { args: send }, function (response) {
                if (!response.error) {
                    let res = response.result.data.details
                    $scope.studentList = res;
                    $scope.$apply();
                }
            });
        $scope.gotoStudentSubjectReport = (user_id) => {
            $mdDialog.hide()
            parentScopeObj.getStudentReport(send, user_id)
        }

        $scope.cancel = function() {
            $mdDialog.cancel();
        }
    }
}
export default StudentFilteration;


// WEBPACK FOOTER //
// ./src/app/educore_reports/inidividual/controllers/controller.js